import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Send cookies for session-based auth
});

// Request interceptor - add CSRF token
api.interceptors.request.use(
  (config) => {
    // Get CSRF token from meta tag
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (token) {
      config.headers['X-CSRF-TOKEN'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Flag to prevent multiple simultaneous redirects
let isRedirecting = false;

// Response interceptor - handle errors globally
api.interceptors.response.use(
  (response) => {
    // Update CSRF token if Laravel sends a new one in response headers
    const newToken = response.headers['x-csrf-token'];
    if (newToken) {
      const metaTag = document.querySelector('meta[name="csrf-token"]');
      if (metaTag) {
        metaTag.setAttribute('content', newToken);
      }
    }
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle specific error codes
      switch (error.response.status) {
        case 401:
        case 419:
          // 401: Unauthorized - user not authenticated
          // 419: CSRF token mismatch - session expired
          if (!isRedirecting) {
            isRedirecting = true;
            console.error('Session expired or authentication lost');
            
            // Show alert to user
            alert('Your session has expired. Please log in again.');
            
            // Clear any local storage/session data
            localStorage.removeItem('user');
            localStorage.removeItem('selectedCompanyId');
            sessionStorage.clear();
            
            // Redirect to login page
            window.location.href = '/login';
          }
          break;
        case 403:
          console.error('Forbidden:', error.response.data.message);
          break;
        case 404:
          console.error('Not found:', error.response.data.message);
          break;
        case 422:
          // Validation error
          console.error('Validation error:', error.response.data);
          break;
        case 429:
          // Rate limit exceeded
          console.error('Rate limit exceeded');
          alert('Too many requests. Please wait a moment and try again.');
          break;
        case 500:
          console.error('Server error:', error.response.data.message);
          break;
      }
    } else if (error.request) {
      console.error('Network error:', error.message);
    } else {
      console.error('Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;
